<template>
    <section id="content">
        <loader v-if="loader == true"></loader>
        <div class="page page-hz-menu-layout">
            <div class="row">
                <div class="col-md-8">
                    <section class="tile">
                        <div class="tile-header dvd dvd-btm">
                            <h1 class="custom-font"><strong>Vendedores</strong></h1>
                            <span @click="openModal" class="img-adicionar pull-right"><img src="https://img.icons8.com/?size=100&id=21097&format=png&color=000000"/> Adicionar</span>
                        </div>
                        <div class="tile-body">
                            <div class="row">
                                <div class="col-md-12 table-responsive">
                                    <p v-if="vendedores.length == 0" align="center"><br>Não exitem contas para pagamentos cadastradas.</p>
                                    <table class="table table-hover table-striped" v-if="vendedores.length > 0">
                                        <thead>
                                        <tr>
                                            <th>Vendedor</th>
                                            <th>Celular</th>
                                            <th>Criado em</th>
                                            <th></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="lc in vendedores" @click="selectVendedor(lc)" class="table-row">
                                            <td @dblclick="editVendedor(lc)">
                                                <template v-if="editingVendedor === lc.id">
                                                    <input type="text" class="edit-vendedor" v-model="lc.nome_vendedor" @blur="saveEdit(lc)" @keyup.enter="saveEdit(lc)">
                                                </template>
                                                <template v-else>
                                                    {{ lc.nome_vendedor }}
                                                </template>
                                            </td>
                                            <td @dblclick="editVendedor(lc)">
                                                <template v-if="editingVendedor === lc.id">
                                                    <input type="text" class="edit-vendedor" v-model="lc.celular_vendedor" v-mask="'(##) #####-####'" @blur="saveEdit(lc)" @keyup.enter="saveEdit(lc)">
                                                </template>
                                                <template v-else>
                                                    <img class="whats-icon" src="https://img.icons8.com/?size=100&id=16713&format=png&color=000000" width="21" @click="openWhatsApp(lc.celular_vendedor)"/>
                                                    {{ lc.celular_vendedor }}
                                                </template>
                                            </td>
                                            <td>{{ formatDate(lc.created_at) }}</td>
                                            <td align="right">
                                                <span class="icon-excluir"
                                                    @click.stop="excluir(lc.id)"
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Excluir">
                                                    <img src="https://img.icons8.com/?size=100&id=DpBZenCy2pa3&format=png&color=000000"/>
                                                </span>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <transition name="slide-fade">
                    <div class="col-md-4" v-if="selectedVendedor">
                        <section class="tile">
                            <div class="tile-header dvd dvd-btm">
                                <h1 class="custom-font"><strong>Informações do Vendedor</strong></h1>
                                <button class="btn-close pull-right" @click="closeVendedorDetails">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                            <div class="tile-body">
                                <p><strong>Nome: <span style="font-size: 18px; color:#7cb716">{{ selectedVendedor.nome_vendedor }}</span></strong></p>
                                <p><strong>Criado em:</strong> {{ formatDate(selectedVendedor.created_at) }}</p>
                                <p><strong>Total de Propostas:</strong> {{ totalPropostas }}</p>
                                <span @click="gerarGrafico()" class="icon-grafico"><img src="https://img.icons8.com/?size=100&id=D0A1Afld5jac&format=png&color=000000" width="31"/> Gerar Gráfico</span>
                            </div>
                        </section>
                    </div>
                </transition>

                <transition name="slide-fade">
                    <div class="col-md-8" v-if="selectedVendedor">
                        <section class="tile">
                            <div class="tile-header dvd dvd-btm">
                                <h1 class="custom-font"><strong>Propostas</strong></h1>
                                <button class="btn-close pull-right" @click="closeVendedorDetails">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                            <div class="tile-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="startDate">Data Inicial:</label>
                                        <input type="date" id="startDate" class="input-data" v-model="startDate" @change="filterPropostas">
                                    </div>
                                    <div class="col-md-6">
                                        <label for="endDate">Data Final:</label>
                                        <input type="date" id="endDate" class="input-data" v-model="endDate" @change="filterPropostas">
                                    </div>
                                </div>
                                <table class="table table-hover table-striped" v-if="filteredPropostas.length > 0">
                                    <thead>
                                        <tr>
                                            <th>Vendedor</th>
                                            <th>Valor Proposta</th>
                                            <th>Criado em</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="p in filteredPropostas" :key="p.id" class="table-row">
                                            <td>
                                                <router-link
                                                    :to="{ name: 'ViewProposta', params: { id: p.id, origem: 'E' } }"
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Visualizar Proposta"
                                                >
                                                    {{ p.id }}
                                                </router-link>
                                            </td>
                                            <td>{{ formatCurrency(p.valor_proposta) }}</td>
                                            <td>{{ formatDate(p.created_at) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>
                    </div>
                </transition>     
                
                <transition name="slide-fade">
                    <div class="col-md-4" v-if="selectedVendedorGrafico == 'true'">
                        <section class="tile">
                            <div class="tile-header dvd dvd-btm">
                                <h1 class="custom-font"><strong>Gráfico Propostas</strong></h1>
                                <button class="btn-close pull-right" @click="closeVendedorDetailsGrafico">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                            <div class="tile-body">
                                <div class="chart-container">
                                    <pie-chart ref="pieChart" :chart-data="chartData" :options="chartOptions"></pie-chart>
                                </div>
                            </div>
                        </section>
                    </div>
                </transition>
            </div>
        </div>

        <!-- Modal -->
        <div v-if="showModal" class="modal-overlay">
            <div class="modal-container">
                <div class="modal-header">
                    <h3>Adicionar Vendedor</h3>
                    <button class="btn-close" @click="closeModal">×</button>
                </div>
                <div class="modal-body">
                    <label for="nomeVendedor">Nome do Vendedor:</label>
                    <input type="text" class="input-vendedor" id="nomeVendedor" v-model="newVendedor.nome_vendedor">
                    <label for="celularVendedor">Celular: <img src="https://img.icons8.com/?size=100&id=16713&format=png&color=000000" width="21"/></label>
                    <input type="text" class="input-vendedor" id="celularVendedor" v-model="newVendedor.celular_vendedor" v-mask="'(##) #####-####'">
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" @click="saveVendedor">Salvar</button>
                    <button class="btn btn-secondary" @click="closeModal">Cancelar</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { mask } from 'vue-the-mask'
    import moment from "moment";
    import { Pie } from 'vue-chartjs'

    export default {
        directives: {
            mask,
            moment
        },

        components: {
            PieChart: {
                extends: Pie,
                props: ['chartData', 'options'],
                mounted() {
                    this.renderChart(this.chartData, this.options)
                }
            }
        },

        data() {
            return {
                chartData: {
                    labels: ['Total de Propostas da Loja', 'Propostas do Vendedor'],
                    datasets: [{
                        label: 'Comparação de Propostas',
                        data: [],
                        backgroundColor: [
                            'rgba(54, 162, 235, 0.2)', // Azul claro
                            'rgba(75, 192, 192, 0.2)'  // Azul esverdeado
                        ],
                        borderColor: [
                            'rgba(54, 162, 235, 1)', // Azul claro
                            'rgba(75, 192, 192, 1)'  // Azul esverdeado
                        ],
                        borderWidth: 1
                    }]
                },
                chartOptions: {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top',
                        },
                        title: {
                            display: true,
                            text: 'Comparação de Propostas'
                        },
                        tooltip: {
                            callbacks: {
                                label: (context) => {
                                    let label = context.dataset.label || '';
                                    if (label) {
                                        label += ': ';
                                    }
                                    if (context.raw !== null) {
                                        label += context.raw;
                                    }
                                    return label;
                                },
                                afterLabel: (context) => {
                                    const proposta = this.filteredPropostas[context.dataIndex];
                                    return `Data: ${this.formatDate(proposta.created_at)}`;
                                }
                            }
                        }
                    }
                },

                startDate: '',
                endDate: '',
                filteredPropostas: [],
                editingVendedor: null,
                loader: false,
                vendedores: [],
                idLojista: localStorage.getItem('userid'),
                selectedVendedor: null,
                selectedVendedorGrafico: 'null',
                showModal: false,
                newVendedor: {
                    nome_vendedor: '',
                    celular_vendedor: ''
                },
                propostas: [],
                totalPropostasMes: 0,
                totalPropostas: 0,
                totalPropostasLojista: 0
            }
        },

        methods: {
            gerarGrafico() {
                this.selectedVendedorGrafico = 'true';
                this.updateChartData();
            },
            updateChartData() {
                const totalPropostas = this.totalPropostasLojista.total_propostas;
                const propostasVendedor = this.filteredPropostas.length;
                this.chartData.datasets[0].data = [totalPropostas, propostasVendedor];
                this.$refs.pieChart.renderChart(this.chartData, this.chartOptions);
            },
            selectVendedor(vendedor) {
                this.getPropostasVendedor(vendedor.id);
                this.selectedVendedorGrafico = 'null';
                this.selectedVendedor = vendedor;
            },
            formatCurrency(value) {
                return new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                }).format(value);
            },
            formatDate(data) {
                return moment(data).format("DD/MM/YYYY")
            },
            getlistaVendedor: function () {
                var $this = this;
                $this.loader = true;

                $this.$http.post('/lojista/vendedor', {idLojista: this.idLojista})
                .then(function (response) {
                    $this.vendedores = response.data;
                    $this.loader = false;
                })
                .catch(function (error) {
                    $this.loader = false;
                })
            },
            filterPropostas() {
                this.getPropostasVendedorFilter(this.selectedVendedor.id, this.startDate, this.endDate);
                this.selectedVendedorGrafico = 'null';
            },
            getPropostasVendedorFilter() {
                var $this = this;
                $this.loader = true;

                $this.$http.post('/propostas/getPropostasVendedorFilter', { id_vendedor: this.selectedVendedor.id, startDate: this.startDate, endDate: this.endDate })
                    .then(function (response) {
                        $this.propostas = response.data;
                        $this.filteredPropostas = response.data;
                        $this.loader = false;
                        $this.calculateTotals();
                        if ($this.selectedVendedorGrafico === 'true') {
                            $this.updateChartData();
                        }
                    })
                    .catch(function (error) {
                        $this.loader = false;
                    });
            },
            getTotalPropostas() {
                var $this = this;
                $this.loader = true;
                $this.$http.post('/propostas/getTotalPropostas', { id_lojista: this.idLojista })
                    .then(function (response) {
                        $this.totalPropostasLojista = response.data;
                        $this.loader = false;
                    })
                    .catch(function (error) {
                        $this.loader = false;
                    });
            },
            getPropostasVendedor(idVendedor) {
                var $this = this;
                $this.loader = true;
                $this.$http.post('/propostas/getPropostasVendedor', { id_vendedor: idVendedor })
                    .then(function (response) {
                        $this.propostas = response.data;
                        $this.filteredPropostas = response.data;
                        $this.loader = false;
                        $this.calculateTotals();
                        if ($this.selectedVendedorGrafico === 'true') {
                            $this.updateChartData();
                        }
                    })
                    .catch(function (error) {
                        $this.loader = false;
                    });
            },
            calculateTotals() {
                const currentMonth = moment().month();
                this.totalPropostas = this.filteredPropostas.length;
                this.totalPropostasMes = this.filteredPropostas.filter(p => moment(p.created_at).month() === currentMonth).length;
            },
            closeVendedorDetails() {
                this.selectedVendedor = null;
            },
            closeVendedorDetailsGrafico() {
                this.selectedVendedorGrafico = 'null';
            },
            openModal() {
                this.showModal = true;
            },
            closeModal() {
                this.showModal = false;
                this.newVendedor.nome_vendedor = '';
                this.newVendedor.celular_vendedor = '';
            },
            editVendedor(vendedor) {
                this.editingVendedor = vendedor.id;
            },
            saveEdit(vendedor) {
                this.editingVendedor = null;
                var $this = this;
                $this.loader = true;

                $this.$http.post('/lojista/updateVendedor', { nome_vendedor: vendedor.nome_vendedor, celular_vendedor: vendedor.celular_vendedor, id: vendedor.id })
                .then(function (response) {
                    $this.loader = false;
                    $this.$toastr('success', 'Vendedor atualizado com sucesso.', 'Atenção!');
                    $this.getlistaVendedor();
                    $this.closeModal();
                })
                .catch(function (error) {
                    $this.loader = false;
                });
            },
            saveVendedor() {
                var $this = this;
                $this.loader = true;

                $this.$http.post('/lojista/novoVendedor', { nome_vendedor: this.newVendedor.nome_vendedor, celular_vendedor: this.newVendedor.celular_vendedor, id_lojista: this.idLojista })
                .then(function (response) {
                    $this.loader = false;
                    $this.newVendedor.nome_vendedor = '';
                    $this.newVendedor.celular_vendedor = '';
                    $this.$toastr('success', 'Vendedor cadastrado com sucesso.', 'Atenção!');
                    $this.getlistaVendedor();
                    $this.closeModal();
                })
                .catch(function (error) {
                    $this.loader = false;
                });
            },
            excluir(id) {
                var $this = this;
                $this.loader = true;

                swal({
                    title: "Atenção",
                    text: 'Deseja realmente excluir?',
                    type: "warning",
                    buttons: true,
                    showCancelButton: true,
                    dangerMode: true,
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                })
                .then((willDelete) => {
                    if (willDelete.value) {
                    $this.$http.post('/lojista/deleteVendedor/', {id: id})
                    .then(function () {
                        $this.getlistaVendedor();
                        $this.loader = false;
                        swal.close();
                    });
                } else {
                    $this.loader = false;
                    swal.close();
                }
            });
            },
            openWhatsApp(celular) {
                const formattedNumber = celular.replace(/\D/g, ''); // Remove non-numeric characters
                const whatsappUrl = `https://wa.me/55${formattedNumber}`;
                window.open(whatsappUrl, '_blank');
            }
        },

        mounted() {
            this.getlistaVendedor();
            this.getTotalPropostas(); 
        }
    }
</script>

<style scoped>
.chart-container {
    width: 100%;
    max-width: 300px; /* Ajuste o tamanho máximo do gráfico aqui */
    margin: 0 auto;
}

.input-data {
    background: #e7eaeb;
    border: none;
    padding: 4px;
    border-radius: 10px;
}

.table-row {
    cursor: pointer;
}

.table-row:hover {
    background-color: #f5f5f5;
}

.tile {
    border-radius: 10px;
}

.slide-fade-enter-active, .slide-fade-leave-active {
    transition: all 0.5s ease;
}

.slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(-10px);
    opacity: 0;
}

.icon-grafico:hover img{
    cursor: pointer;
    transform: scale(1.1);
}

.whats-icon:hover{
    transform: scale(1.5);
}

.icon-grafico:hover {
    font-size: 16px;
}

.icon-grafico {
    cursor: pointer;
    font-weight: bold;
    color:#5cb85c
   
}

.img-adicionar {
    cursor: pointer;
}

.img-adicionar img {
    width: 20px;
}

.img-adicionar:hover {
    color: #5cb85c;
    transform: scale(1.1);
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-container {
    background: white;
    padding: 20px;
    border-radius: 10px;
    width: 400px;
    max-width: 100%;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-body {
    margin-top: 10px;
}

.modal-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.btn-close {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
}

.input-vendedor {
    background-color: #f5f5f5;
    border: none;
    padding: 10px;
    border-radius: 10px;
    width: 100%;
    margin-bottom: 10px;
}

.icon-excluir :hover {
    transform: scale(1.3);
}

.icon-excluir img {
    width: 20px;
}

.edit-vendedor {
    background-color: #ffffff;
    border: none;
    padding: 5px;
    border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/views/vendedores/Index.vue